import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../../_models/garantias-idoneas';
import {ListaService} from '../../../_services/lista.service';
import {NavService} from '../../../_services/_nav.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {GarantiaIdoneasTipoProductoService} from '../../../_services/garantia-idoneas-tipo-producto.service';
import {TipoProductoresService} from '../../../_services/tipo-producto.service';
import {TiposProductores} from '../../../_models/tipos-productores';
import {GarantiasIdoneasTipoProductor} from '../../../_models/garantias-idoneas-tipo-producto';

@Component( {
  selector: 'app-garantia-idoneas-tipo-producto',
  templateUrl: 'garantia-idoneas-tipo-producto.component.html'
} )

export class GarantiaIdoneasTipoProductoComponent implements OnInit {

  formulario: FormGroup;
  /** items */
  @Input() garantia: GarantiasIdoneas;
  destino: GarantiasIdoneasTipoProductor;

  /** Listas */
  listaTiposProductores: TiposProductores[] = [];
  listGarantiasIdoneasTiposProductores: GarantiasIdoneasTipoProductor[] = [];
  lisDestino: SelectItem[] = [];


  columnas: any[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  indicadorPlan = false;
  @ViewChild('dt') tabla: Table;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private garantiasIdoneasTipoProductoServices: GarantiaIdoneasTipoProductoService,
    private tipoProductoresService: TipoProductoresService,
    private confirmacionServicio: ConfirmationService,
  ) {
  }

  ngOnInit() {

    if ( this.garantia && (this.garantia.idGarantiaIdonea !== '' && this.garantia.idGarantiaIdonea !== null && this.garantia.idGarantiaIdonea !== undefined) ) {
      /** Se carga garantias Servicios */
      forkJoin(
        this.garantiasIdoneasTipoProductoServices.listadoPorTipoProducto( this.garantia.idGarantiaIdonea ),
        this.tipoProductoresService.listadoHabilitados()
      ).subscribe( ( [ garantiaDestinos, lisDestinoC ] ) => {
        this.listGarantiasIdoneasTiposProductores = garantiaDestinos;
        this.listaTiposProductores = lisDestinoC;
        this.cargarInformacionInicial();
      } );
    }
  }

  get getGarantiasTiposProductores() {
    return this.listGarantiasIdoneasTiposProductores.filter( s => s.indicadorHabilitado );
    this.carTabla = false;
  }


  cargarInformacionInicial() {

    this.carTabla = false;
    this.columnas = [
      { field: 'codigoTipoProductor', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORCODIGO' ), sort: true },
      { field: 'tipoProductor', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORNOMBRE' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.formulario = this.fb.group( {
      idGarantiaIdonea: [ this.destino ? this.destino.idGarantiaIdonea : null ],
      idTiposProductores: [ [], [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.carDropdown();

    this.indicadorPlan = false;
    this.carInformacionInicial = false;
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const forData = this.formulario.value;
      const tempTipoProductor: GarantiasIdoneasTipoProductor[] = [];
      forData.idTiposProductores.forEach(tipo => {
        let temp  = {} as GarantiasIdoneasTipoProductor;
        temp.idGarantiaIdonea = this.garantia.idGarantiaIdonea;
        temp.idTipoProductor = tipo;
        temp.indicadorHabilitado = true;
        const a = this.listGarantiasIdoneasTiposProductores.find( sp => sp.idTipoProductor === tipo );
        if ( a ) {
          temp.idGarantiaIdoneaTipoProductor = a.idGarantiaIdoneaTipoProductor;
        }
        tempTipoProductor.push(temp);
      });

      this.garantiasIdoneasTipoProductoServices.bulk( tempTipoProductor ).subscribe( res => {
         const tempSegmentoP: GarantiasIdoneasTipoProductor[] = this.listGarantiasIdoneasTiposProductores;
         this.listGarantiasIdoneasTiposProductores = [];
         res.map(re => {
           re.codigoTipoProductor = this.listaTiposProductores.find( p => p.idTipoProductor === re.idTipoProductor ).codigo;
           re.tipoProductor = this.listaTiposProductores.find( p => p.idTipoProductor === re.idTipoProductor ).nombre;
           tempSegmentoP.map( t => {
              if ( t.idTipoProductor === re.idTipoProductor ) {
                t.indicadorHabilitado = true;
              }
           } );
           if(!tempSegmentoP.find(di => di.idTipoProductor ===  re.idTipoProductor)){
             tempSegmentoP.push(re);
           }
         });
         this.listGarantiasIdoneasTiposProductores = tempSegmentoP;
         this.carDropdown();
         this.formulario.reset();
         this.submitted = false;
         this.guardando = false;
      } );
    }
  }

  disable( row: GarantiasIdoneasTipoProductor ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Garantías idóneas Tipo de productor',
      icon: 'fa fa-question-circle',
      key: 'garantia-idoneas-tipo-productor',
      accept: () => {
        row.indicadorHabilitado = false;
        this.garantiasIdoneasTipoProductoServices.actualizar( row ).subscribe( res => {
          const temp: GarantiasIdoneasTipoProductor[] = this.listGarantiasIdoneasTiposProductores;
          this.listGarantiasIdoneasTiposProductores = [];
          temp.map( t => {
            if ( t.idGarantiaIdoneaTipoProductor === row.idGarantiaIdoneaTipoProductor ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.listGarantiasIdoneasTiposProductores = temp;
          this.carDropdown();
        } );
      }
    } );
  }

  carDropdown(): void {
    this.lisDestino = [];
    this.listaTiposProductores.map(  s => {
      if ( !this.listGarantiasIdoneasTiposProductores.find( ga => ga.indicadorHabilitado &&
        ga.idTipoProductor === s.idTipoProductor) ) {
        this.lisDestino.push( { label: s.nombre, value: s.idTipoProductor } );
      }
    } );
  }




  }
